import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Row,
  Col,
  notification,
  Flex,
  Typography,
  Dropdown,
  Select,
  TreeSelect
} from "antd";
import {
  ExpandOutlined,
  ShrinkOutlined,
  QuestionCircleOutlined,
  DownOutlined

} from "@ant-design/icons";

// import VariantAttributeList from "../../VariantAttributeList";
import VariationDetails from "../../VariationDetails";
import VariantProductList from "../../VariantProductList";
import UploadButton from "../../../common/UploadButton";
import globalData from "../../../../config/global_data";
import ErrorNotification from "../../../common/ErrorNotification";
import apiService from "../../Api";
import StatusBadge from "../../../common/StatusBadge";
import common_api from "../../../../config/common_api";
import CommonAttributeList from "../../../common/CommonAttributeList";
import { triggerNotification } from "../../../common/notify";

const ButtonItems = [
  {
    label: 'Save as Draft',
    key: 'saveDraft',
  },
  {
    label: 'Save & Reload',
    key: 'saveReload',
  },
];

const DrawerNew = ({ visible, onClose, selected_prod_data, setisloader, selectedData, variant_detils, reload , globalList, setGlobalList}) => {
  const [form] = Form.useForm();
  const [bundleTitle, setBundleTitle] = useState("New Variant Product");
  const [data, setData] = useState(selected_prod_data);
  const [treeData, setTreeData] = useState(null)
  const [stores, setStoreOptions] = useState([]);
  const [imageObj, setImageObj] = useState(null);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [savedimages, setSavedimgaes] = useState(null);
  const [savedattributes, setSavedattributes] = useState(null);
  const [savedVariants, setSavedVariants] = useState(null);
  const [savedVariantOptions, setSavedVariantOptions] = useState(null);
  const [alert, setAlert] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedStores, setSelectedStores] = useState('');
  const [selectedStoreID, setSelectedStoreID] = useState(null);
  const [removedValues, setRemovedValues] = useState(null);

  const handleInputChange = (name) => (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    form.setFieldsValue({ [name]: value });
  };

  useEffect(() => {      
    
    if (globalData && globalData.store_list && globalData.store_list.length > 0) {
      setStoreOptions(globalData.store_list.map(store => ({
        label: store.label,
        value: store.value,
        store_id: store.store_id,
      })));
      if (selectedData && selectedData.length > 0) {
        setSelectedStores(selectedData[0].store)
        if (
          globalData &&
          globalData.all_cat_list &&
          globalData.all_cat_list.length > 0
        ) {
          let cattree = globalData.all_cat_list.filter(item => item.store_id === selectedData[0].store_id);
          if (cattree && cattree.length > 0 && cattree[0].treedata) {
            setTreeData(cattree[0].treedata);
          }
        }
      }
    }
  }, []);


  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };
  useEffect(() => {
    const fetchData = () => {
      if (
        globalData &&
        globalData.all_cat_list &&
        globalData.all_cat_list.length > 0 &&
        selected_prod_data &&
        selected_prod_data.store_id
      ) {
        let cattree = globalData.all_cat_list.filter(item => item.store_id === selected_prod_data.store_id);
        if (cattree && cattree.length > 0 && cattree[0].treedata) {
          setTreeData(cattree[0].treedata);
        }
      }
    };

  }, [selected_prod_data, visible]);

  const handleAlert = async (type, title, message, isopen) => {
    setAlert({ type, title, message, isopen });
    setTimeout(() => setAlert({ isopen: false }), 100);
  };
  const handleSaveAndPublish = async (values) => {

    let images = []
    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }
      })
    }
    let custom_fields_final = [], custom_fields_removed = [];
    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { values, attribute_key, max_size } = attr;

        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item.val) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "name": baseKey.replace("NUM", counter),
                "value": item.val
              }
            } else if (max_size === 1) {
              itemobj = {
                "name": baseKey,
                "value": item.val
              }
            }
            else {
              itemobj = {
                "name": baseKey + "_" + counter,
                "value": item.val
              }
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    if (removedValues && removedValues.custom_fields && removedValues.custom_fields.length > 0) {
      custom_fields_removed = removedValues.custom_fields
    }
    let mapped_variant_data = [], option_array = []

    if (savedVariants && savedVariants.variants) {
      await savedVariants.variants.map(item => {
        let jsonob = {
          "price": parseFloat(item.variant_default_price ? item.variant_default_price : 0),
          "sale_price": parseFloat(item.variant_sale_price),
          "retail_price": parseFloat(item.variant_msrp),
          "inventory_level": parseInt(item.inventory_available),
          "inventory_warning_level": parseInt(item.inventory_warning_level ? item.inventory_warning_level : 0),
          "image_url": item.variant_image ? item.variant_image : "",
          "sku": item.variant_sku
          // image_url:
        }

        if (savedVariantOptions) {
          let option_values = [{
            "option_display_name": savedVariantOptions.option_display_name,
            "label": item.variant_name
          }]
          jsonob.option_values = option_values
        } else {
          triggerNotification({
            type: 'error',
            title: 'Error!',
            message: "Please Check Variant details",
          });
          return 1;
        }
        // if (item.options && item.options.length > 0) {

        //   if (!item.is_new) {
        //     // delete item.options[0].id
        //     delete option_array.option_display_name
        //     option_array.push(item.options[0])
        //   }
        //   if (item.is_new) {

        //     // jsonob.option_array
        //     item.options[0].label = item.options[0].label
        //     item.options[0].id = 0
        //     item.options[0].is_default = false
        //     // delete  item.options[0].id
        //     // delete  item.options[0].option_id
        //     jsonob.option_values = item.options
        //     option_array.push(item.options[0])
        //   }
        // }
        if (item.cost_price && item.cost_price != "") {
          jsonob.cost_price = item.cost_price
        }
        if (item.weight && item.weight != "") {
          jsonob.weight = item.weight
        }
        if (item.width && item.width != "") {
          jsonob.width = item.width
        }
        if (item.height && item.height != "") {
          jsonob.height = item.height
        }
        if (item.depth && item.depth != "") {
          jsonob.depth = item.depth
        }
        mapped_variant_data.push(jsonob)

      })

    } else {
      triggerNotification({
        type: 'error',
        title: 'Error!',
        message: "Please Check Variant details",
      });
      return 1;
    }


    let req_data = {
      "store": selectedStores,
      "is_variant": true,
      "data": {
        "name": values.bc_name,
        "sku": values.bcSku,
        "weight": 0,
        "type": "physical",
        "price": values.msrpPrice.replace(data.currency_symbol, ""),
        "sale_price": values.salePrice.replace(data.currency_symbol, ""),
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues,
        "inventory_tracking": "variant",
        variants: mapped_variant_data
      },
      custom_fields_removed,
      "variant_type": {
        type: savedVariantOptions.type,
        display_name: savedVariantOptions.option_display_name
      }
    }

    // return 1
    if (req_data) {
      setisloader(true)
      let responsedata = await common_api.create_simple_product(req_data)
      if (responsedata) {
        // await reload(true);
        let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata, true)
        if (alldata) {
          await setGlobalList(alldata)
        }
        triggerNotification(responsedata)
      }
      setisloader(false)
    }
    onClose()
    // handleAlert('success', "Success", "Product Updated Successfully!", true);
  }
  const onChange = (values) => {
    setSelectedValues(values);
  };

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };
  const handleBlur = () => {
    const bundleName = form.getFieldValue("bc_name");
    if (bundleName) {
      setBundleTitle(bundleName);
    }
  };
  const store_options_handleChange = async (value) => {
    let store_id_data = await globalData.store_list.filter(item => item.value === value)
    if (globalData.all_cat_list && globalData.all_cat_list.length > 0) {
      let cattree = await globalData.all_cat_list.filter(item => item.store_id === store_id_data[0].store_id)
      if (cattree && cattree.length > 0) {
        setTreeData(cattree[0].treedata)
      }
    }
    setSelectedStoreID(store_id_data[0].store_id)
    setSelectedStores(value);
  };
  return (
    data && <Drawer className={`NEwabc DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="DrawerButtonBox">
              <Button
                className="ExpandDrawer"
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ marginRight: 8 }}
              >
                {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
              </Button>
              <ErrorNotification {...alert} />

              <Dropdown.Button
                type="primary"
                icon={<DownOutlined />}
                menu={{
                  items: ButtonItems,
                  onClick: handleMenuClick,
                }}
                trigger={['click']}
                onClick={handleSaveAndPublishClick}
                style={{ marginLeft: 8 }}
              >
                Save & Publish
              </Dropdown.Button>
            </div>
          </div>

        </>
      }
    >
      <Form layout="vertical" form={form}>
        <div className="DraftBox">
          <StatusBadge
            status={form.getFieldValue("status")}
            lastEdited="21-06-2025, 12:45GMT" // You can make this dynamic if needed
          />
        </div>
        <Flex className="flexbox">
          {/* <Form.Item label="Store" className="disabledstore">
            <Input placeholder="US" value={data.store} disabled />
          </Form.Item> */}
          <Form.Item className="w-100"
            label={
              <span>
                Product Name&nbsp;
                {/* <QuestionCircleOutlined
                  style={{
                    color: "rgba(0, 0, 0, 0.45)",
                    cursor: "pointer",
                  }}
                  title="This is the name shown on the product Variant."
                /> */}
              </span>
            }
            name="bc_name"
            rules={[{ required: true, message: "Please enter product Name" }]}
          >
            <Input placeholder="Enter product Name" onBlur={handleBlur} value={bundleTitle} />
          </Form.Item>

        </Flex>
        <Form.Item
          label={
            <span>
              SKU&nbsp;
              {/* <QuestionCircleOutlined
                style={{
                  color: "rgba(0, 0, 0, 0.45)",
                  cursor: "pointer",
                }}
                title="This is the SAP SKU."
              /> */}
            </span>
          }
          name="bcSku"
          rules={[{ required: true, message: "Please Enter Sku" }]}
          className="sap_sku_select"
        >
          <Input
            style={{ width: "100%" }}
            placeholder="Enter SAP SKU"

          />
        </Form.Item>
        <Form.Item label="Store" className="" style={{ width: "200px" }}>
          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder="Select Store"
            value={selectedStores}
            options={stores}
            onChange={store_options_handleChange}
            disabled
          />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Product Categories&nbsp;
              {/* <QuestionCircleOutlined
                style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                title="Select categories from the category list."
              /> */}
            </span>
          }
          rules={[{ required: true, message: "Please select at least one category" }]}
        >

          <div>

            <TreeSelect
              className="CategoryTree"
              multiple
              treeData={treeData}
              value={selectedValues}
              onChange={onChange}
              placeholder="Please select categories"
            />
          </div>
        </Form.Item>
        <Form.Item
          label={
            <span>
              Image&nbsp;
              {/* <QuestionCircleOutlined
                style={{
                  color: "rgba(0, 0, 0, 0.45)",
                  cursor: "pointer",
                }}
                title="This is the PDP Gallery."
              /> */}
            </span>
          }
          name="PDPGallery"
        >
          <UploadButton
            MAX_UPLOADS="50"
            delete="true"
            replace="true"
            thumbnail="true"
            hover="true"
            setSavedimgaes={setSavedimgaes}
            product_obj={imageObj}
          />
        </Form.Item>
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Store MSRP&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{
                      color: "rgba(0, 0, 0, 0.45)",
                      cursor: "pointer",
                    }}
                    title="This is the Store MSRP."
                  /> */}
                </span>
              }
              name="msrpPrice"
              rules={[
                { required: true, message: "Please enter the Store MSRP" },
              ]}               
            >
              <Input placeholder="Enter MSRP" onChange={handleInputChange("msrpPrice")}  prefix={selectedData[0].currency_symbol}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Sale Price&nbsp;                  
                </span>
              }
              name="salePrice"
              rules={[
                { required: true, message: "Please enter the sale price" },
              ]}
             
            >
              <Input placeholder="Enter Sale Price" onChange={handleInputChange("salePrice")}  prefix={selectedData[0].currency_symbol}/>
            </Form.Item>
          </Col>
        </Row>


        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
          {visible && selected_prod_data && <CommonAttributeList setRemovedValues={setRemovedValues} setSavedattributes={setSavedattributes} customfielddata={selected_prod_data} />}

          {/* {visible && selected_prod_data && <VariantAttributeList setSavedattributes={setSavedattributes} customfielddata={selected_prod_data} />} */}
        </div>
        {visible && <VariationDetails variantoption={null} setSavedVariantOptions={setSavedVariantOptions} variant_detils={variant_detils} />}
        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes VariantProductList" : ""}`}>
          {visible && selectedData && <VariantProductList setSavedVariants={setSavedVariants} variantdata={null} newdata={selectedData} form={form} />}
        </div>
      </Form>
    </Drawer>
  );
};
export default DrawerNew;